// Permission definitions
export const PERMISSIONS = {
  // Company
  COMPANY_READ: 'company:read',
  COMPANY_WRITE: 'company:write',
  COMPANY_DELETE: 'company:delete',

  // Employees
  EMPLOYEES_READ: 'employees:read',
  EMPLOYEES_WRITE: 'employees:write',
  EMPLOYEES_DELETE: 'employees:delete',
  EMPLOYEES_IMPORT: 'employees:import',
  EMPLOYEES_EXPORT: 'employees:export',

  // Attendance
  ATTENDANCE_READ: 'attendance:read',
  ATTENDANCE_WRITE: 'attendance:write',
  ATTENDANCE_CHECK_IN: 'attendance:check-in',
  ATTENDANCE_CHECK_OUT: 'attendance:check-out',

  // Schedules
  SCHEDULES_READ: 'schedules:read',
  SCHEDULES_WRITE: 'schedules:write',
  SCHEDULES_DELETE: 'schedules:delete',

  // Workflow
  WORKFLOW_READ: 'workflow:read',
  WORKFLOW_WRITE: 'workflow:write',
  WORKFLOW_APPROVE: 'workflow:approve',
  WORKFLOW_CREATE: 'workflow:create',
  WORKFLOW_READ_OWN: 'workflow:read-own',

  // Reports
  REPORTS_READ: 'reports:read',
  REPORTS_EXPORT: 'reports:export',

  // Profile
  PROFILE_READ: 'profile:read',
  PROFILE_WRITE: 'profile:write',

  // Roles & Permissions
  ROLES_READ: 'roles:read',
  ROLES_WRITE: 'roles:write',
  ROLES_DELETE: 'roles:delete',

  // All permissions (Super Admin only)
  ALL: '*',
} as const;

export type Permission = typeof PERMISSIONS[keyof typeof PERMISSIONS];

